"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertInputToOutputInteraction = convertInputToOutputInteraction;
function convertInputToOutputInteraction(sessionInteractionInput) {
    switch (sessionInteractionInput.kind) {
        case "text":
            return {
                sessionKind: sessionInteractionInput.sessionKind,
                sessionId: sessionInteractionInput.sessionId,
                _id: sessionInteractionInput._id,
                createdAt: sessionInteractionInput.createdAt,
                updatedAt: sessionInteractionInput.updatedAt,
                kind: "text",
                text: sessionInteractionInput.text,
                from: "user",
                needsReply: false,
                assessment: null,
            };
        case "audio":
            return {
                sessionKind: sessionInteractionInput.sessionKind,
                sessionId: sessionInteractionInput.sessionId,
                _id: sessionInteractionInput._id,
                createdAt: sessionInteractionInput.createdAt,
                updatedAt: sessionInteractionInput.updatedAt,
                kind: "audio",
                audioURL: sessionInteractionInput.audioURL,
                from: "user",
                needsReply: false,
            };
        case "audio:text":
            return {
                sessionKind: sessionInteractionInput.sessionKind,
                sessionId: sessionInteractionInput.sessionId,
                _id: sessionInteractionInput._id,
                createdAt: sessionInteractionInput.createdAt,
                updatedAt: sessionInteractionInput.updatedAt,
                kind: "audio:text",
                text: sessionInteractionInput.text,
                audioURL: sessionInteractionInput.audioURL,
                from: "user",
                needsReply: false,
                assessment: null,
            };
        case "audio:buffer": {
            return {
                sessionKind: sessionInteractionInput.sessionKind,
                sessionId: sessionInteractionInput.sessionId,
                _id: sessionInteractionInput._id,
                createdAt: sessionInteractionInput.createdAt,
                updatedAt: sessionInteractionInput.updatedAt,
                kind: sessionInteractionInput.kind,
                audioBuffer: sessionInteractionInput.audioBuffer,
                from: "user",
                needsReply: false,
            };
        }
        case "image": {
            return {
                sessionKind: sessionInteractionInput.sessionKind,
                sessionId: sessionInteractionInput.sessionId,
                _id: sessionInteractionInput._id,
                createdAt: sessionInteractionInput.createdAt,
                updatedAt: sessionInteractionInput.updatedAt,
                kind: sessionInteractionInput.kind,
                imageURL: sessionInteractionInput.imageURL,
                from: "user",
                needsReply: false,
                assessment: null,
            };
        }
        default:
            throw new Error(`Convert ${sessionInteractionInput.kind} input to output is not supported`);
    }
}
//# sourceMappingURL=session.utils.js.map